import store from "./store";

export default function init() {
  /* Fetch and Set the current user in case there's one */
  if (localStorage.getItem("id_token")) {
    store.dispatch("currentUser");
  }
}
